import { combineReducers } from "redux";
import Theme from "./Theme";

const reducers = combineReducers({
  theme: Theme,
});

export default reducers;
